/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Send_ButtonInputs */

const en_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send email`)
};

const fr_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l'e-mail`)
};

const de_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail senden`)
};

const it_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia email`)
};

const ru_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить письмо`)
};

const es_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar correo`)
};

const zh_cn2_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送邮件`)
};

const ja_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを送信`)
};

const hi_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल भेजें`)
};

const pt_pt2_explorer_assignment_email_send_button = /** @type {(inputs: Explorer_Assignment_Email_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar e-mail`)
};

/**
* | output |
* | --- |
* | "Send email" |
*
* @param {Explorer_Assignment_Email_Send_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_send_button = /** @type {((inputs?: Explorer_Assignment_Email_Send_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Send_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_send_button(inputs)
	if (locale === "de") return de_explorer_assignment_email_send_button(inputs)
	if (locale === "it") return it_explorer_assignment_email_send_button(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_send_button(inputs)
	if (locale === "es") return es_explorer_assignment_email_send_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_send_button(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_send_button(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_send_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_send_button(inputs)
	return en_explorer_assignment_email_send_button(inputs)
});